import { createFileRoute, redirect } from '@tanstack/react-router';

import { readRestoreChatId } from '@/lib/session-restore';
import { MicrosoftConsentReturn } from '@/screens/microsoft-consent/MicrosoftConsentReturn';

/** Home → new chat, except when Microsoft returns from the admin-consent flow. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Microsoft admin-consent uses the app root as its redirect_uri, so the
    // admin lands back on `/` with ?admin_consent=... (or ?error=... on
    // failure): the guided consent of a Microsoft 365 integration (with our
    // signed state) and the SSO consent link (without). Only the adminconsent
    // flow reaches `/` with these params — normal login errors go to /login.
    // MicrosoftConsentReturn completes the one and confirms the other.
    const params = new URLSearchParams(window.location.search);
    if (!params.has('admin_consent') && !params.has('error')) {
      // The native app only ever reaches `/` on a cold start — nothing inside
      // the app navigates here — so this is the one place that can put the user
      // back into the chat the OS interrupted them in (KAN-547). Null on the
      // web, and in the app whenever there is nothing recent to restore.
      const restoredChatId = readRestoreChatId();
      if (restoredChatId) {
        throw redirect({ to: '/chat/$id', params: { id: restoredChatId } });
      }
      throw redirect({ to: '/chat/new' });
    }
  },
  component: MicrosoftConsentReturn,
});
